export default __webpack_public_path__ + "static/First-8bd76da0db552870201b948462d13d30.jpg";